<template>
  <footer class="flex justify-between gap-4 w-full">
    <CButton @click="emit('cancel')">
      {{ t('canvasUI.common.cancel') }}
    </CButton>

    <CButton type="primary" @click="emit('close')">
      {{ t('canvasUI.common.done') }}
    </CButton>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'

const emit = defineEmits<{
  close: []
  cancel: []
}>()

const { t } = useI18n()
</script>
